import MarketCell from './MarketCell';

export default MarketCell;
